export const cl = {
  root: {
    flexDirection: { xs: "column", md: "row" },
    width: "100%",
    justifyContent: { xs: "flex-start", md: "space-between" },
    alignItems: "center",
    gap: { xs: "32px", md: "20px" },
    height: { xs: "auto", md: "calc(100svh - 104.5px)" },
    minHeight: { xs: "100svh", md: "auto" },
    p: { xs: "60px 16px 50px 16px", md: "0px 80px" },
    boxSizing: "border-box",
    textAlign: { xs: "center", md: "left" },
  },
  textContainer: {
    justifyContent: "center",
    alignItems: { xs: "center", md: "flex-start" },
    width: { xs: "100%", md: "40%" },
    gap: { xs: "8px", md: "24px" },
  },
  button: {
    mt: { xs: "16px", md: "24px" },
    width: { xs: "100%", sm: "225px" },
    height: { xs: "44px", md: "60px" },
    fontSize: "16px",
  },
  videoContainer: {
    width: { xs: "100%", md: "55%" },
    justifyContent: "center",
    alignItems: "end",
    aspectRatio: "16 / 9",
    zIndex: 100,
    maxHeight: { xs: "50vh", md: "70%" },
    height: "100%",
    border: "1px #EAECF0 solid",
    borderRadius: { xs: "8px", md: "20px" },
    overflow: "hidden",
    "& video": {
      width: "100%",
      height: "100%",
    },
  },
};
